var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYfii(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.716 17.875H13.14c-1.001 1.931-3.147 2.933-5.079 2.933-1.93 0-4.506-1.43-5.006-4.435s1.931-5.58 4.006-6.01c1.66-.343 3.124.382 3.648.788l-3.22.43.216 2.074 6.796-1.001L13.14 6l-2.003.5.501 2.648a36.962 36.962 0 0 1-1.43-.644c-.43-.215-2.648-.716-4.436 0-1.788.715-3.72 2.146-4.435 4.364-.716 2.217-.358 5.436 1.717 7.725 2.074 2.29 5.365 2.862 7.869 1.86 2.003-.8 4.03-3.386 4.793-4.578zm.425-4.039 2.414-.028c.758-2.04 2.765-3.296 4.682-3.532 1.917-.236 4.648.87 5.512 3.79.865 2.921-1.235 5.774-3.241 6.454-1.606.543-3.147.003-3.718-.335l3.142-.82-.466-2.032-6.623 1.824 2.162 6.437 1.927-.742-.82-2.566a36.91 36.91 0 0 1 1.498.465c.452.161 2.714.387 4.402-.541 1.687-.93 3.43-2.586 3.869-4.874.44-2.289-.309-5.44-2.647-7.459-2.34-2.018-5.675-2.184-8.038-.884-1.89 1.04-3.442 3.567-4.054 4.843zm9.376.891H6.631v1.86h18.886v-1.86z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYfii);
export default __webpack_public_path__ + "static/media/YFII.87527da2a9b8eec90b34bdbc14795b62.svg";
export { ForwardRef as ReactComponent };